// Shared coordination logic for ticket purchase dialog auto-opening
// This ensures only one dialog auto-opens across all concert list components

let hasAutoOpenedDialog = false

/**
 * Atomically check and claim the auto-open flag
 * Returns true if this call successfully claimed it, false otherwise
 */
export function tryClaimAutoOpen() {
  if (!hasAutoOpenedDialog) {
    hasAutoOpenedDialog = true
    return true
  }
  return false
}

/**
 * Reset the flag (useful for testing or if needed)
 */
export function resetAutoOpenFlag() {
  hasAutoOpenedDialog = false
}
